import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { TrendingUp, TrendingDown, AlertTriangle, BarChart3, Share2, Calendar, MapPin, Euro, Fuel, Banknote, Download, Truck, Ship, Plane, Building, Target, Users, Package, Clock, Leaf, Network, DollarSign, Zap } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { useLanguage } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { Link } from "react-router-dom";
const Index = () => {
  const {
    t
  } = useLanguage();

  // Sample data for charts with translated labels
  const freightRatesData = [{
    month: t('month.jul'),
    rate: 2850
  }, {
    month: t('month.aug'),
    rate: 2650
  }, {
    month: t('month.sep'),
    rate: 2400
  }, {
    month: t('month.oct'),
    rate: 2200
  }];
  const inflationData = [
  // 2024 Data
  {
    month: t('month.jan') + ' 2024',
    netherlands: 3.1,
    uk: 4.0,
    poland: 2.9,
    slovakia: 2.8,
    france: 2.9,
    germany: 2.9,
    spain: 3.1,
    italy: 0.8,
    sweden: 3.4
  }, {
    month: t('month.feb') + ' 2024',
    netherlands: 2.8,
    uk: 3.4,
    poland: 2.8,
    slovakia: 2.7,
    france: 2.8,
    germany: 2.5,
    spain: 2.8,
    italy: 0.9,
    sweden: 3.1
  }, {
    month: t('month.mar') + ' 2024',
    netherlands: 2.7,
    uk: 3.2,
    poland: 2.0,
    slovakia: 2.9,
    france: 2.4,
    germany: 2.2,
    spain: 3.2,
    italy: 1.2,
    sweden: 2.9
  }, {
    month: t('month.apr') + ' 2024',
    netherlands: 2.6,
    uk: 2.3,
    poland: 2.5,
    slovakia: 2.8,
    france: 2.4,
    germany: 2.4,
    spain: 3.3,
    italy: 0.8,
    sweden: 2.2
  }, {
    month: t('month.may') + ' 2024',
    netherlands: 2.8,
    uk: 2.0,
    poland: 2.8,
    slovakia: 2.9,
    france: 2.6,
    germany: 2.4,
    spain: 3.6,
    italy: 0.8,
    sweden: 2.3
  }, {
    month: t('month.jun') + ' 2024',
    netherlands: 3.2,
    uk: 2.0,
    poland: 2.6,
    slovakia: 2.7,
    france: 2.5,
    germany: 2.2,
    spain: 3.5,
    italy: 0.9,
    sweden: 2.6
  }, {
    month: t('month.jul') + ' 2024',
    netherlands: 3.7,
    uk: 2.2,
    poland: 4.2,
    slovakia: 2.8,
    france: 2.6,
    germany: 2.3,
    spain: 2.8,
    italy: 1.3,
    sweden: 2.6
  }, {
    month: t('month.aug') + ' 2024',
    netherlands: 3.3,
    uk: 2.2,
    poland: 4.3,
    slovakia: 2.8,
    france: 2.2,
    germany: 1.9,
    spain: 2.4,
    italy: 1.1,
    sweden: 2.2
  }, {
    month: t('month.sep') + ' 2024',
    netherlands: 3.3,
    uk: 1.7,
    poland: 4.9,
    slovakia: 2.8,
    france: 1.7,
    germany: 1.6,
    spain: 1.5,
    italy: 0.7,
    sweden: 1.1
  }, {
    month: t('month.oct') + ' 2024',
    netherlands: 3.2,
    uk: 1.7,
    poland: 5.0,
    slovakia: 2.8,
    france: 2.0,
    germany: 2.0,
    spain: 1.8,
    italy: 0.9,
    sweden: 1.6
  }, {
    month: t('month.nov') + ' 2024',
    netherlands: 3.8,
    uk: 2.3,
    poland: 4.7,
    slovakia: 2.9,
    france: 2.3,
    germany: 2.2,
    spain: 2.4,
    italy: 1.4,
    sweden: 1.8
  }, {
    month: t('month.dec') + ' 2024',
    netherlands: 4.0,
    uk: 2.5,
    poland: 4.8,
    slovakia: 3.0,
    france: 2.4,
    germany: 2.6,
    spain: 2.8,
    italy: 1.3,
    sweden: 2.2
  },
  // 2025 Data
  {
    month: t('month.jan') + ' 2025',
    netherlands: 3.6,
    uk: 2.9,
    poland: 4.6,
    slovakia: 3.2,
    france: 2.4,
    germany: 2.3,
    spain: 2.4,
    italy: 1.2,
    sweden: 2.0
  }, {
    month: t('month.feb') + ' 2025',
    netherlands: 3.1,
    uk: 3.4,
    poland: 3.7,
    slovakia: 3.1,
    france: 2.6,
    germany: 2.7,
    spain: 2.8,
    italy: 1.0,
    sweden: 1.8
  }, {
    month: t('month.mar') + ' 2025',
    netherlands: 2.9,
    uk: 3.2,
    poland: 2.0,
    slovakia: 2.8,
    france: 2.4,
    germany: 2.2,
    spain: 3.1,
    italy: 1.1,
    sweden: 2.1
  }, {
    month: t('month.apr') + ' 2025',
    netherlands: 2.7,
    uk: 2.3,
    poland: 2.4,
    slovakia: 2.6,
    france: 2.4,
    germany: 2.1,
    spain: 3.3,
    italy: 0.8,
    sweden: 1.9
  }, {
    month: t('month.may') + ' 2025',
    netherlands: 2.8,
    uk: 2.0,
    poland: 2.7,
    slovakia: 2.7,
    france: 2.6,
    germany: 2.4,
    spain: 3.6,
    italy: 0.8,
    sweden: 2.2
  }, {
    month: t('month.jun') + ' 2025',
    netherlands: 3.0,
    uk: 2.0,
    poland: 2.5,
    slovakia: 2.5,
    france: 2.5,
    germany: 2.2,
    spain: 3.4,
    italy: 0.9,
    sweden: 2.4
  }, {
    month: t('month.jul') + ' 2025',
    netherlands: 3.2,
    uk: 2.2,
    poland: 4.0,
    slovakia: 2.6,
    france: 2.4,
    germany: 2.3,
    spain: 2.6,
    italy: 1.2,
    sweden: 2.3
  }, {
    month: t('month.aug') + ' 2025',
    netherlands: 2.8,
    uk: 2.2,
    poland: 4.1,
    slovakia: 2.6,
    france: 2.2,
    germany: 1.9,
    spain: 2.2,
    italy: 1.0,
    sweden: 2.0
  }, {
    month: t('month.sep') + ' 2025',
    netherlands: 2.4,
    uk: 1.7,
    poland: 4.7,
    slovakia: 2.6,
    france: 2.0,
    germany: 1.6,
    spain: 1.7,
    italy: 0.7,
    sweden: 1.3
  }, {
    month: t('month.oct') + ' 2025',
    netherlands: 2.6,
    uk: 1.7,
    poland: 4.8,
    slovakia: 2.7,
    france: 2.1,
    germany: 2.0,
    spain: 1.8,
    italy: 0.9,
    sweden: 1.5
  }];
  const dieselPricesData = [
  // 2024 Data
  {
    month: t('month.jan') + ' 2024',
    netherlands: 1.54,
    germany: 1.50,
    uk: 1.48,
    poland: 1.35,
    slovakia: 1.42
  }, {
    month: t('month.feb') + ' 2024',
    netherlands: 1.53,
    germany: 1.49,
    uk: 1.47,
    poland: 1.34,
    slovakia: 1.41
  }, {
    month: t('month.mar') + ' 2024',
    netherlands: 1.55,
    germany: 1.51,
    uk: 1.49,
    poland: 1.36,
    slovakia: 1.43
  }, {
    month: t('month.apr') + ' 2024',
    netherlands: 1.56,
    germany: 1.52,
    uk: 1.50,
    poland: 1.37,
    slovakia: 1.44
  }, {
    month: t('month.may') + ' 2024',
    netherlands: 1.57,
    germany: 1.53,
    uk: 1.51,
    poland: 1.38,
    slovakia: 1.45
  }, {
    month: t('month.jun') + ' 2024',
    netherlands: 1.58,
    germany: 1.54,
    uk: 1.52,
    poland: 1.39,
    slovakia: 1.46
  }, {
    month: t('month.jul') + ' 2024',
    netherlands: 1.59,
    germany: 1.55,
    uk: 1.53,
    poland: 1.40,
    slovakia: 1.47
  }, {
    month: t('month.aug') + ' 2024',
    netherlands: 1.60,
    germany: 1.56,
    uk: 1.54,
    poland: 1.41,
    slovakia: 1.48
  }, {
    month: t('month.sep') + ' 2024',
    netherlands: 1.58,
    germany: 1.54,
    uk: 1.52,
    poland: 1.39,
    slovakia: 1.46
  }, {
    month: t('month.oct') + ' 2024',
    netherlands: 1.58,
    germany: 1.54,
    uk: 1.52,
    poland: 1.39,
    slovakia: 1.46
  }, {
    month: t('month.nov') + ' 2024',
    netherlands: 1.60,
    germany: 1.56,
    uk: 1.54,
    poland: 1.41,
    slovakia: 1.48
  }, {
    month: t('month.dec') + ' 2024',
    netherlands: 1.61,
    germany: 1.57,
    uk: 1.55,
    poland: 1.42,
    slovakia: 1.49
  },
  // 2025 Data
  {
    month: t('month.jan') + ' 2025',
    netherlands: 1.62,
    germany: 1.58,
    uk: 1.56,
    poland: 1.43,
    slovakia: 1.50
  }, {
    month: t('month.feb') + ' 2025',
    netherlands: 1.63,
    germany: 1.59,
    uk: 1.57,
    poland: 1.44,
    slovakia: 1.51
  }, {
    month: t('month.mar') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.apr') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.may') + ' 2025',
    netherlands: 1.65,
    germany: 1.61,
    uk: 1.59,
    poland: 1.46,
    slovakia: 1.53
  }, {
    month: t('month.jun') + ' 2025',
    netherlands: 1.65,
    germany: 1.61,
    uk: 1.59,
    poland: 1.46,
    slovakia: 1.53
  }, {
    month: t('month.jul') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.aug') + ' 2025',
    netherlands: 1.63,
    germany: 1.59,
    uk: 1.57,
    poland: 1.44,
    slovakia: 1.51
  }, {
    month: t('month.sep') + ' 2025',
    netherlands: 1.64,
    germany: 1.60,
    uk: 1.58,
    poland: 1.45,
    slovakia: 1.52
  }, {
    month: t('month.oct') + ' 2025',
    netherlands: 1.65,
    germany: 1.61,
    uk: 1.59,
    poland: 1.46,
    slovakia: 1.53
  }];
  const minimumWageData = [{
    country: 'Netherlands',
    wage: 12.83,
    color: '#FF6B35'
  }, {
    country: 'Germany',
    wage: 12.41,
    color: '#FFD23F'
  }, {
    country: 'United Kingdom',
    wage: 11.44,
    color: '#004E89'
  }, {
    country: 'Poland',
    wage: 4.30,
    color: '#DC143C'
  }, {
    country: 'Slovakia',
    wage: 4.50,
    color: '#9A031E'
  }];

  // PDF Generation Function
  const generatePDF = () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    const currentDate = new Date().toLocaleDateString();
    const pdfContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>LogiSense Portal Report - ${currentDate}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; color: #333; }
          .header { text-align: center; border-bottom: 2px solid #3b82f6; padding-bottom: 20px; margin-bottom: 30px; }
          .header h1 { color: #3b82f6; margin: 0; font-size: 28px; }
          .header p { color: #666; margin: 5px 0; }
          .section { margin-bottom: 30px; page-break-inside: avoid; }
          .section h2 { color: #1f2937; border-left: 4px solid #3b82f6; padding-left: 15px; font-size: 20px; }
          .section h3 { color: #374151; font-size: 16px; margin-top: 20px; }
          .card { border: 1px solid #e5e7eb; border-radius: 8px; padding: 15px; margin: 15px 0; background: #f9fafb; }
          .badge { display: inline-block; padding: 4px 8px; border-radius: 4px; font-size: 12px; font-weight: bold; }
          .badge-red { background: #fee2e2; color: #dc2626; }
          .badge-orange { background: #fed7aa; color: #ea580c; }
          .badge-green { background: #dcfce7; color: #16a34a; }
          .badge-blue { background: #dbeafe; color: #2563eb; }
          .stats { display: flex; justify-content: space-between; margin: 10px 0; }
          .stat { text-align: center; }
          .stat-value { font-size: 18px; font-weight: bold; color: #3b82f6; }
          .stat-label { font-size: 12px; color: #666; }
          .insights { background: #f0f9ff; border-left: 4px solid #0ea5e9; padding: 15px; margin: 15px 0; }
          .insights h4 { margin: 0 0 10px 0; color: #0c4a6e; }
          .insights ul { margin: 0; padding-left: 20px; }
          .insights li { margin: 5px 0; color: #0c4a6e; }
          @media print { body { margin: 0; } .section { page-break-inside: avoid; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>LogiSense Portal</h1>
          <p>European Logistics News & Risk Intelligence</p>
          <p>Report Generated: ${currentDate}</p>
        </div>

        <div class="section">
          <h2>Latest Risk Sensing</h2>
          
          <div class="card">
            <h3><span class="badge badge-red">HIGH RISK</span> Rotterdam and Antwerp Port Still Congested After End of Strikes</h3>
            <p><strong>Date:</strong> Oct 5-18, 2025 | <strong>Status:</strong> RECOVERING</p>
            <p>While strikes have officially ended in both Rotterdam and Antwerp ports, significant congestion persists with vessel backlogs continuing to impact European logistics operations.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">90+</div>
                <div class="stat-label">Ships Waiting (Peak)</div>
              </div>
              <div class="stat">
                <div class="stat-value">14 days</div>
                <div class="stat-label">Strike Duration</div>
              </div>
              <div class="stat">
                <div class="stat-value">Ongoing</div>
                <div class="stat-label">Recovery Status</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3><span class="badge badge-red">HIGH RISK</span> COSCO Chartered Boxship Caught in China Port Fee Dispute</h3>
            <p><strong>Date:</strong> October 28, 2025 | <strong>Status:</strong> ACTIVE</p>
            <p>A COSCO-operated containership skipped China calls after becoming subject to new port fees targeting US-linked vessels, demonstrating strict enforcement even against state-owned companies.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">Halley</div>
                <div class="stat-label">Vessel (2,550 TEU)</div>
              </div>
              <div class="stat">
                <div class="stat-value">Seeking Exemption</div>
                <div class="stat-label">Status</div>
              </div>
              <div class="stat">
                <div class="stat-value">High Risk</div>
                <div class="stat-label">Impact Level</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3><span class="badge badge-red">HIGH RISK</span> AWS Outage Disrupts Global Supply Chains</h3>
            <p><strong>Date:</strong> October 25, 2025 | <strong>Status:</strong> RESOLVED</p>
            <p>A major Amazon Web Services outage lasting over 4 hours caused widespread disruptions to supply chain management systems across Europe and North America.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">4.2 hours</div>
                <div class="stat-label">Total Duration</div>
              </div>
              <div class="stat">
                <div class="stat-value">$2.3B</div>
                <div class="stat-label">Economic Impact</div>
              </div>
              <div class="stat">
                <div class="stat-value">98%</div>
                <div class="stat-label">Recovery Rate</div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <h2>Industry Highlights</h2>
          
          <div class="card">
            <h3><span class="badge badge-red">DECLINING</span> European Logistics Firms Face Impact from Falling Freight Rates</h3>
            <p><strong>Date:</strong> October 15, 2025</p>
            <p>European shipping and logistics firms are under pressure as ocean container rates plunge to their lowest since January 2024, driven by industry oversupply and weaker demand following new U.S. tariffs.</p>
          </div>

          <div class="card">
            <h3><span class="badge badge-green">EXPANSION</span> FS Logistix Takes Over Train Connection Between Antwerp and Milan</h3>
            <p><strong>Date:</strong> October 18, 2025</p>
            <p>Italy's FS Logistix has taken over the Antwerp-Milan intermodal train service, operating five times weekly and removing approximately 13,000 trucks from European roads annually.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">5</div>
                <div class="stat-label">Weekly Connections</div>
              </div>
              <div class="stat">
                <div class="stat-value">13,000</div>
                <div class="stat-label">Trucks Removed/Year</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3><span class="badge badge-blue">NEW POLICY</span> Europe's New Carbon Market for Buildings and Road Transport</h3>
            <p><strong>Date:</strong> October 22, 2025</p>
            <p>The EU's new Emissions Trading System (ETS2) will cover CO2 emissions from buildings and road transport starting 2027, complementing existing climate policies to achieve 2050 neutrality goals.</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">2027</div>
                <div class="stat-label">Launch Date</div>
              </div>
              <div class="stat">
                <div class="stat-value">42%</div>
                <div class="stat-label">Emission Reduction by 2030</div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <h2>Macroeconomic Index</h2>
          
          <div class="card">
            <h3>Average EU Diesel Fuel Prices</h3>
            <p>Monthly average prices per liter (EUR) - January 2024 to October 2025</p>
            <div class="insights">
              <h4>Key Insights</h4>
              <ul>
                <li>Average EU diesel price trend from €1.52 to €1.63/liter</li>
                <li>Lowest average was €1.51/liter in February 2024</li>
                <li>Highest averages reached €1.63/liter in 2025</li>
                <li>Overall increase of €0.11/liter over 22-month period</li>
              </ul>
            </div>
          </div>

          <div class="card">
            <h3>European Inflation Rate</h3>
            <p>Euro Area annual inflation rate (%) - October 2025 Update</p>
            <div class="stats">
              <div class="stat">
                <div class="stat-value">2.1%</div>
                <div class="stat-label">Current Rate</div>
              </div>
              <div class="stat">
                <div class="stat-value">2.0%</div>
                <div class="stat-label">ECB Target</div>
              </div>
              <div class="stat">
                <div class="stat-value">+0.1pp</div>
                <div class="stat-label">Monthly Change</div>
              </div>
              <div class="stat">
                <div class="stat-value">2.7%</div>
                <div class="stat-label">Core Inflation</div>
              </div>
            </div>
          </div>

          <div class="card">
            <h3>Average EU Minimum Wage</h3>
            <p>Annual average minimum wage rates (EUR/hour) - 2020 to 2025</p>
            <div class="insights">
              <h4>Key Insights</h4>
              <ul>
                <li>2025 shows highest average at €11.48/hour</li>
                <li>2020 baseline was €10.85/hour</li>
                <li>Steady growth trend over 6-year period</li>
                <li>Average annual increase of €0.13/hour since 2020</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="section">
          <h2>Logistics Partners Insights</h2>
          
          <div class="card">
            <h3>DHL Global Connectedness Tracker - October 2025</h3>
            <p><strong>Special Update:</strong> Shifts in Global Business Amid Trade Policy Turbulence</p>
            <div class="insights">
              <h4>Key Takeaways</h4>
              <ul>
                <li>Global trade grew faster in H1 2025 than any half-year since 2010 (excluding pandemic)</li>
                <li>Tariff increases prompted trade forecast downgrades for 2025-2026, but growth expected to continue</li>
                <li>International investment shows mixed signals with uncertainty deterring some cross-border deals</li>
                <li>U.S.-China decoupling continues - direct trade share dropped to only 9% in 2025</li>
              </ul>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 40px; padding-top: 20px; border-top: 1px solid #e5e7eb; color: #666; font-size: 12px;">
          <p>Generated from LogiSense Portal | ${currentDate}</p>
          <p>For the latest updates, visit: https://8wjtubsrmt.skywork.website</p>
        </div>
      </body>
      </html>
    `;
    printWindow.document.write(pdfContent);
    printWindow.document.close();

    // Wait for content to load, then trigger print
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };
  const ShareButton = ({
    title
  }: {
    title: string;
  }) => <Button variant="outline" size="sm" className="ml-auto">
      <Share2 className="h-4 w-4 mr-2" />
      {t('common.share')}
    </Button>;
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-blue-900">{t('header.title')}</h1>
              <p className="text-blue-600 mt-1">{t('header.subtitle')}</p>
            </div>
            <div className="flex items-center space-x-4">
              
              <LanguageSwitcher />
              <Badge variant="outline" className="text-blue-700 border-blue-200">
                <Calendar className="h-4 w-4 mr-1" />
                {t('header.week')}
              </Badge>
            </div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-6 py-8 space-y-12">
        {/* WK 43 Industry Highlights */}
        <section id="industry-highlights">
          <div className="flex items-center mb-8">
            <BarChart3 className="h-8 w-8 text-blue-600 mr-3" />
            <h2 className="text-3xl font-bold text-gray-900">{t('industry.title')}</h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* EU Duty-Free Imports Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://www.euractiv.com/content/uploads/sites/2/2025/11/GettyImages-2216065007-e1763100924238.jpg" alt="EU customs and trade policy" className="w-full h-[192px] object-cover" />
                <Badge className="absolute top-4 left-4 bg-purple-500">
                  <AlertTriangle className="h-3 w-3 mr-1" />
                  {t('article.euduty.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.euduty.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.euduty.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.euduty.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Current Threshold:</span>
                    <span className="font-semibold text-red-600">€150 (Ending 2026)</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Implementation:</span>
                    <span className="font-semibold">2 years early</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Impact:</span>
                    <span className="font-semibold text-green-600">Millions of parcels</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.euduty.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.open('https://nltimes.nl/2025/11/13/eu-end-duty-free-imports-2026-amid-surge-cheap-goods-china', '_blank')}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="EU Duty-Free Imports Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* FM Logistic Intermodal Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://logisticsmonitor.eu/wp-content/uploads/2025/10/jpeg-optimizer_A7404872-1-2048x1536-1.jpg" alt="Intermodal rail and road transport" className="w-full h-[192px] object-cover" />
                <Badge className="absolute top-4 left-4 bg-green-500">
                  <Leaf className="h-3 w-3 mr-1" />
                  {t('article.fmlogistic.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.fmlogistic.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.fmlogistic.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.fmlogistic.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">CO₂ Reduction:</span>
                    <span className="font-semibold text-green-600">68% vs Road</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Route:</span>
                    <span className="font-semibold">Poland-France</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Savings per Journey:</span>
                    <span className="font-semibold text-green-600">1.8 tonnes CO₂</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.fmlogistic.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.open('https://logisticsmonitor.eu/news_v2/fm-logistic-launches-new-intermodal-route-linking-poland-and-northern-france/', '_blank')}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="FM Logistic Intermodal Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Carrier Alliances Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Container shipping alliances" className="w-full h-[192px] object-cover" />
                <Badge className="absolute top-4 left-4 bg-blue-500">
                  <Network className="h-3 w-3 mr-1" />
                  {t('article.alliances.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.alliances.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.alliances.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.alliances.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">New Alliances:</span>
                    <span className="font-semibold text-blue-600">Gemini & Premier</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">MSC Strategy:</span>
                    <span className="font-semibold">Standalone</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Impact:</span>
                    <span className="font-semibold text-green-600">Global Trade</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.alliances.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.open('https://cargofive.com/carrier-alliances-transform-freight-forwarding/', '_blank')}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Carrier Alliances Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Warehousing Costs Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Modern warehouse operations" className="w-full h-[192px] object-cover" />
                <Badge className="absolute top-4 left-4 bg-orange-500">
                  <TrendingUp className="h-3 w-3 mr-1" />
                  {t('article.warehousing.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.warehousing.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.warehousing.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.warehousing.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Europe Index:</span>
                    <span className="font-semibold text-red-600">119.6 (Highest)</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">North America:</span>
                    <span className="font-semibold text-orange-600">113.4 (Rising)</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Asia Pacific:</span>
                    <span className="font-semibold text-green-600">110.8 (Stable)</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.warehousing.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.open('https://ti-insight.com/briefs/stabilising-global-warehousing-costs-although-europe-remains-the-most-expensive/', '_blank')}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Warehousing Costs Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Maersk Q3 Results Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://www.maersk.com/~/media_sc9/maersk/news/press-releases/images/2025/09/maersk-san-vincent-at-yard_1024x576.jpg?w=1056&hash=388F80681775B6BC1ACA951C0CA08C97" alt="Maersk container operations" className="w-full h-[192px] object-cover" />
                <Badge className="absolute top-4 left-4 bg-green-500">
                  <DollarSign className="h-3 w-3 mr-1" />
                  {t('article.maersk.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.maersk.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.maersk.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.maersk.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Q3 EBITDA:</span>
                    <span className="font-semibold text-green-600">$2.69B (vs $2.58B est.)</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Container Demand:</span>
                    <span className="font-semibold text-blue-600">3-5% Growth</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Q4 Outlook:</span>
                    <span className="font-semibold text-orange-600">Cautious</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.maersk.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.open('https://www.reuters.com/business/retail-consumer/maersk-posts-third-quarter-operating-profit-above-forecast-2025-11-06/', '_blank')}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Maersk Q3 Results Article" />
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Electric Inland Vessels Article */}
            <Card className="hover:shadow-lg transition-shadow">
              <div className="relative h-48 overflow-hidden rounded-t-lg">
                <img src="https://vlootschouw.nl/wp-content/uploads/2021/02/Den-Bosch-Max-Groen_web.jpg" alt="Electric inland shipping vessels" className="w-full h-[192px] object-cover" />
                <Badge className="absolute top-4 left-4 bg-green-500">
                  <Zap className="h-3 w-3 mr-1" />
                  {t('article.electric.badge')}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">{t('article.electric.title')}</CardTitle>
                <CardDescription className="flex items-center text-sm">
                  <Calendar className="h-4 w-4 mr-1" />
                  {t('article.electric.date')}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-4">
                  {t('article.electric.summary')}
                </p>
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">CO₂ Savings:</span>
                    <span className="font-semibold text-green-600">800 tonnes/year</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Battery Swap:</span>
                    <span className="font-semibold">15 minutes</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Operating Hours:</span>
                    <span className="font-semibold text-blue-600">8 hours per charge</span>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  <Badge variant="secondary">{t('article.electric.badge')}</Badge>
                  <div className="flex space-x-2">
                    <Button variant="outline" size="sm" onClick={() => window.open('https://www.france24.com/en/live-news/20250925-dutch-lead-charge-on-electric-inland-vessels', '_blank')}>
                      {t('common.readMore')}
                    </Button>
                    <ShareButton title="Electric Inland Vessels Article" />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        <Separator />

        {/* Market Insights */}
        <section id="market-insights" className="py-12 bg-gradient-to-br from-blue-50 to-indigo-50">
          <div className="container mx-auto px-6">
            <div className="flex items-center mb-8">
              <TrendingUp className="h-8 w-8 text-blue-600 mr-3" />
              <div>
                <h2 className="text-3xl font-bold text-gray-900">{t('market.title')}</h2>
                <p className="text-gray-600 mt-1">{t('market.subtitle')}</p>
              </div>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              {/* Road Freight Market */}
              <Card className="hover:shadow-lg transition-shadow">
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <Truck className="h-6 w-6 text-orange-600" />
                    <Badge variant="outline" className="text-orange-600 border-orange-200">
                      Critical
                    </Badge>
                  </div>
                  <CardTitle className="text-lg">{t('market.roadFreight.title')}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-gray-600 mb-4">{t('market.roadFreight.summary')}</p>
                  <div className="space-y-2">
                    <div className="flex items-center text-xs text-gray-500">
                      <AlertTriangle className="h-3 w-3 mr-1 text-red-500" />
                      {t('market.roadFreight.keyPoint1')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingUp className="h-3 w-3 mr-1 text-blue-500" />
                      {t('market.roadFreight.keyPoint2')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingDown className="h-3 w-3 mr-1 text-red-500" />
                      {t('market.roadFreight.keyPoint3')}
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Ocean Freight Market */}
              <Card className="hover:shadow-lg transition-shadow">
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <Ship className="h-6 w-6 text-blue-600" />
                    <Badge variant="outline" className="text-blue-600 border-blue-200">
                      Declining
                    </Badge>
                  </div>
                  <CardTitle className="text-lg">{t('market.oceanFreight.title')}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-gray-600 mb-4">{t('market.oceanFreight.summary')}</p>
                  <div className="space-y-2">
                    <div className="flex items-center text-xs text-gray-500">
                      <BarChart3 className="h-3 w-3 mr-1 text-blue-500" />
                      {t('market.oceanFreight.keyPoint1')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <Clock className="h-3 w-3 mr-1 text-yellow-500" />
                      {t('market.oceanFreight.keyPoint2')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <AlertTriangle className="h-3 w-3 mr-1 text-red-500" />
                      {t('market.oceanFreight.keyPoint3')}
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Air Freight Market */}
              <Card className="hover:shadow-lg transition-shadow">
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <Plane className="h-6 w-6 text-green-600" />
                    <Badge variant="outline" className="text-green-600 border-green-200">
                      Stable
                    </Badge>
                  </div>
                  <CardTitle className="text-lg">{t('market.airFreight.title')}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-gray-600 mb-4">{t('market.airFreight.summary')}</p>
                  <div className="space-y-2">
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingUp className="h-3 w-3 mr-1 text-green-500" />
                      {t('market.airFreight.keyPoint1')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingUp className="h-3 w-3 mr-1 text-green-500" />
                      {t('market.airFreight.keyPoint2')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <AlertTriangle className="h-3 w-3 mr-1 text-orange-500" />
                      {t('market.airFreight.keyPoint3')}
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Real Estate Market */}
              <Card className="hover:shadow-lg transition-shadow">
                <CardHeader className="pb-3">
                  <div className="flex items-center justify-between">
                    <Building className="h-6 w-6 text-purple-600" />
                    <Badge variant="outline" className="text-purple-600 border-purple-200">
                      Cooling
                    </Badge>
                  </div>
                  <CardTitle className="text-lg">{t('market.realEstate.title')}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-gray-600 mb-4">{t('market.realEstate.summary')}</p>
                  <div className="space-y-2">
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingDown className="h-3 w-3 mr-1 text-red-500" />
                      {t('market.realEstate.keyPoint1')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingUp className="h-3 w-3 mr-1 text-green-500" />
                      {t('market.realEstate.keyPoint2')}
                    </div>
                    <div className="flex items-center text-xs text-gray-500">
                      <TrendingUp className="h-3 w-3 mr-1 text-green-500" />
                      {t('market.realEstate.keyPoint3')}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Recommendations Section */}
            <Card className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
              <CardHeader>
                <div className="flex items-center">
                  <Target className="h-6 w-6 mr-3" />
                  <CardTitle className="text-xl">{t('market.recommendations.title')}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <div className="flex items-start space-x-3">
                    <div className="bg-white/20 rounded-full p-2 mt-1">
                      <Users className="h-4 w-4" />
                    </div>
                    <div>
                      <p className="text-sm font-medium">{t('market.recommendations.point1')}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="bg-white/20 rounded-full p-2 mt-1">
                      <Package className="h-4 w-4" />
                    </div>
                    <div>
                      <p className="text-sm font-medium">{t('market.recommendations.point2')}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="bg-white/20 rounded-full p-2 mt-1">
                      <Clock className="h-4 w-4" />
                    </div>
                    <div>
                      <p className="text-sm font-medium">{t('market.recommendations.point3')}</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="bg-white/20 rounded-full p-2 mt-1">
                      <Calendar className="h-4 w-4" />
                    </div>
                    <div>
                      <p className="text-sm font-medium">{t('market.recommendations.point4')}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
            
            {/* Read Full Report Button */}
            <div className="text-center mt-8">
              <Button 
                onClick={() => window.location.hash = '/article/monthly-logistics-insights'}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 text-lg"
                size="lg"
              >
                <BarChart3 className="h-5 w-5 mr-2" />
                Read Full Monthly Report
              </Button>
              <p className="text-sm text-gray-600 mt-2">Complete analysis with detailed insights and recommendations</p>
            </div>
          </div>
        </section>

        <Separator />

        {/* Latest Risk Sensing */}
        

        <Separator />

        {/* Logistics Partners Insights */}
        <section id="partners-insights" className="py-12 bg-gradient-to-br from-orange-50 to-yellow-50">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">{t('partners.title')}</h2>
            
            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <BarChart3 className="h-6 w-6 mr-3 text-blue-600" />
                    <div>
                      <CardTitle className="text-xl">{t('partners.kuehne.title')}</CardTitle>
                      <CardDescription className="mt-1">{t('partners.kuehne.subtitle')}</CardDescription>
                    </div>
                  </div>
                  <Badge className="bg-blue-100 text-blue-800 border-blue-200">
                    {t('partners.kuehne.badge')}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent>
                <div className="grid md:grid-cols-2 gap-6">
                  {/* Key Messages */}
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-4">{t('partners.kuehne.keyTakeaways')}</h4>
                    <ul className="space-y-3 text-sm text-gray-700">
                      <li className="flex items-start">
                        <AlertTriangle className="h-4 w-4 mr-2 text-red-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway1')}</span>
                      </li>
                      <li className="flex items-start">
                        <TrendingDown className="h-4 w-4 mr-2 text-orange-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway2')}</span>
                      </li>
                      <li className="flex items-start">
                        <TrendingUp className="h-4 w-4 mr-2 text-blue-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway3')}</span>
                      </li>
                      <li className="flex items-start">
                        <MapPin className="h-4 w-4 mr-2 text-purple-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway4')}</span>
                      </li>
                    </ul>
                  </div>

                  {/* Strategic Implications */}
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-4">{t('partners.kuehne.additionalInsights')}</h4>
                    <ul className="space-y-3 text-sm text-gray-700">
                      <li className="flex items-start">
                        <AlertTriangle className="h-4 w-4 mr-2 text-yellow-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway5')}</span>
                      </li>
                      <li className="flex items-start">
                        <TrendingUp className="h-4 w-4 mr-2 text-red-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway6')}</span>
                      </li>
                      <li className="flex items-start">
                        <BarChart3 className="h-4 w-4 mr-2 text-indigo-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway7')}</span>
                      </li>
                      <li className="flex items-start">
                        <BarChart3 className="h-4 w-4 mr-2 text-green-600 mt-0.5 flex-shrink-0" />
                        <span>{t('partners.kuehne.takeaway8')}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Source Link */}
                <div className="mt-6 p-4 bg-blue-50 rounded-lg border-l-4 border-l-blue-500">
                  <div className="flex items-center justify-between">
                    <div>
                      <h5 className="font-semibold text-blue-800 mb-1">{t('partners.kuehne.source')}</h5>
                      <p className="text-sm text-blue-700">{t('partners.kuehne.sourceDescription')}</p>
                    </div>
                    <a href="https://mykn.kuehne-nagel.com/news/article/europe-has-to-start-taking-port" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                      <span className="mr-2">🚢</span>
                      {t('partners.kuehne.viewTracker')}
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        <Separator />

        {/* Logistics Data */}
        <section id="logistics-data">
          <div className="flex items-center mb-8">
            <BarChart3 className="h-8 w-8 text-blue-600 mr-3" />
            <h2 className="text-3xl font-bold text-gray-900">{t('data.title')}</h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* European Diesel Prices */}
            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center">
                  <Fuel className="h-5 w-5 mr-2 text-blue-600" />
                  {t('data.diesel.title')}
                </CardTitle>
                <CardDescription>{t('data.diesel.subtitle')}</CardDescription>
              </CardHeader>
              <CardContent>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={dieselPricesData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis domain={[1.3, 'dataMax']} />
                    <Tooltip formatter={(value, name) => [`€${value}`, name]} />
                    <Line type="monotone" dataKey="netherlands" stroke="#FF6B35" strokeWidth={2} name="Netherlands" />
                    <Line type="monotone" dataKey="germany" stroke="#FFD23F" strokeWidth={2} name="Germany" />
                    <Line type="monotone" dataKey="uk" stroke="#004E89" strokeWidth={2} name="United Kingdom" />
                    <Line type="monotone" dataKey="poland" stroke="#DC143C" strokeWidth={2} name="Poland" />
                    <Line type="monotone" dataKey="slovakia" stroke="#9A031E" strokeWidth={2} name="Slovakia" />
                  </LineChart>
                </ResponsiveContainer>
                
                {/* Legend */}
                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Countries Legend</h4>
                  <div className="grid grid-cols-3 gap-2 text-sm">
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#FF6B35] mr-2"></div>
                      <span>Netherlands</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#FFD23F] mr-2"></div>
                      <span>Germany</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#004E89] mr-2"></div>
                      <span>United Kingdom</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#DC143C] mr-2"></div>
                      <span>Poland</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#9A031E] mr-2"></div>
                      <span>Slovakia</span>
                    </div>
                  </div>
                </div>
                
                <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                  <h4 className="font-semibold text-blue-800 mb-2">{t('data.diesel.insights')}</h4>
                  <ul className="text-sm text-blue-700 space-y-1">
                    <li>{t('data.diesel.average')}</li>
                    <li>{t('data.diesel.lowest')}</li>
                    <li>{t('data.diesel.highest')}</li>
                    <li>{t('data.diesel.change')}</li>
                  </ul>
                </div>
              </CardContent>
            </Card>

            {/* European Inflation */}
            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center">
                  <Euro className="h-5 w-5 mr-2 text-green-600" />
                  {t('data.inflation.title')}
                </CardTitle>
                <CardDescription>{t('data.inflation.subtitle')}</CardDescription>
              </CardHeader>
              <CardContent>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={inflationData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip formatter={(value, name) => [`${value}%`, name]} />
                    <Line type="monotone" dataKey="netherlands" stroke="#FF6B35" strokeWidth={2} name="Netherlands" />
                    <Line type="monotone" dataKey="germany" stroke="#FFD23F" strokeWidth={2} name="Germany" />
                    <Line type="monotone" dataKey="uk" stroke="#004E89" strokeWidth={2} name="United Kingdom" />
                    <Line type="monotone" dataKey="poland" stroke="#DC143C" strokeWidth={2} name="Poland" />
                    <Line type="monotone" dataKey="slovakia" stroke="#9A031E" strokeWidth={2} name="Slovakia" />
                  </LineChart>
                </ResponsiveContainer>
                
                {/* Legend */}
                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Countries Legend</h4>
                  <div className="grid grid-cols-3 gap-2 text-sm">
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#FF6B35] mr-2"></div>
                      <span>Netherlands</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#FFD23F] mr-2"></div>
                      <span>Germany</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#004E89] mr-2"></div>
                      <span>United Kingdom</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#DC143C] mr-2"></div>
                      <span>Poland</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#9A031E] mr-2"></div>
                      <span>Slovakia</span>
                    </div>
                  </div>
                </div>
                
                <div className="mt-4 p-4 bg-green-50 rounded-lg">
                  <h4 className="font-semibold text-green-800 mb-2">{t('data.inflation.update')}</h4>
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="text-green-700">{t('data.inflation.current')}</span>
                      <div className="font-bold text-lg text-green-800">2.1%</div>
                    </div>
                    <div>
                      <span className="text-green-700">{t('data.inflation.target')}</span>
                      <div className="font-bold text-lg text-green-800">2.0%</div>
                    </div>
                    <div>
                      <span className="text-green-700">{t('data.inflation.monthly')}</span>
                      <div className="font-bold text-green-800">+0.1pp</div>
                    </div>
                    <div>
                      <span className="text-green-700">{t('data.inflation.core')}</span>
                      <div className="font-bold text-green-800">2.7%</div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* European Minimum Wage */}
            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex items-center">
                  <Banknote className="h-5 w-5 mr-2 text-purple-600" />
                  {t('data.minimumWage.title')}
                </CardTitle>
                <CardDescription>{t('data.minimumWage.subtitle')}</CardDescription>
              </CardHeader>
              <CardContent>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={minimumWageData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="country" />
                    <YAxis />
                    <Tooltip formatter={(value, name) => [`€${value}/hour`, name]} />
                    <Bar dataKey="wage" fill="#8b5cf6" />
                  </BarChart>
                </ResponsiveContainer>
                
                {/* Legend */}
                <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-800 mb-3">Countries Legend</h4>
                  <div className="grid grid-cols-3 gap-2 text-sm">
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#FF6B35] mr-2"></div>
                      <span>Netherlands (€12.83)</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#FFD23F] mr-2"></div>
                      <span>Germany (€12.41)</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#004E89] mr-2"></div>
                      <span>United Kingdom (€11.44)</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#DC143C] mr-2"></div>
                      <span>Poland (€4.30)</span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-4 h-0.5 bg-[#9A031E] mr-2"></div>
                      <span>Slovakia (€4.50)</span>
                    </div>
                  </div>
                </div>
                
                <div className="mt-4 p-4 bg-purple-50 rounded-lg">
                  <h4 className="font-semibold text-purple-800 mb-2">{t('data.minimumWage.insights')}</h4>
                  <ul className="text-sm text-purple-700 space-y-1">
                    <li>{t('data.minimumWage.highest')}</li>
                    <li>{t('data.minimumWage.lowest')}</li>
                    <li>{t('data.minimumWage.average')}</li>
                    <li>{t('data.minimumWage.stability')}</li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

      </div>
      {/* Footer */}
      <footer className="bg-blue-900 text-white py-8 mt-12">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div>
              <h3 className="text-xl font-bold mb-2">{t('footer.title')}</h3>
              <p className="text-blue-200">{t('footer.subtitle')}</p>
            </div>
            <div className="mt-4 md:mt-0">
              <p className="text-blue-200 text-sm">
                {t('footer.updated')}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
};
export default Index;